<template>
    <div>
        <vs-popup title="Escolha a ERP para fazer a Integração dos clientes:" 
        :active.sync="isActive"
        @close="$emit('isActiveFalse')"
        style="border-radius: 10px !important;"
        id="erprootmodal"
        class="sizePopup"
        >

            <vs-table 
            ref="table" 
            :data="listERPs" 
            id="tableData"
            :sst="true"
            style="padding: 0 !important;"
            v-model="selected"
            noDataText="Sem dados disponíveis"
            >  

                <div>
                    <vs-dropdown
                        vs-trigger-click
                        class="cursor-pointer mr-4"
                    >
                        <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                            <span class="mr-2">
                                {{ currentPage * maxPerPage - (maxPerPage - 1) }} -
                                {{
                                    listERPs.length - currentPage * maxPerPage > 0
                                        ? currentPage * maxPerPage
                                        : listERPs.length
                                }} of {{ listERPs.length }}
                            </span>
                            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                        </div>
                        <vs-dropdown-menu>
                            <vs-dropdown-item @click="maxPerPage=4">
                                <span>4</span>
                                </vs-dropdown-item>
                                <vs-dropdown-item @click="maxPerPage=10">
                                <span>10</span>
                                </vs-dropdown-item>
                                <vs-dropdown-item @click="maxPerPage=15">
                                <span>15</span>
                                </vs-dropdown-item>
                                <vs-dropdown-item @click="maxPerPage=20">
                                <span>20</span>
                            </vs-dropdown-item>
                        </vs-dropdown-menu>
                    </vs-dropdown>
                </div>

                <template slot="thead">
                    <vs-th class="text-base" sort-key="corporate_name" style="width: 75%; padding-left: 9%;">
                        Nome
                    </vs-th>
                </template>


                <template slot-scope="{data}">
                    <tbody> 
                        <vs-tr 
                            :data="tr" 
                            :key="tr.id"
                            :id="tr.id"
                            v-for="(tr, index) in listERPs.slice(previousNumberRegister, nextNumberRegister)"
                        >
                            <vs-td :data="tr.corporate_name" style="border-top-left-radius: 8px; border-bottom-left-radius: 8px; padding-left: 9%;">
                                <p class="text-left">
                                    {{ tr.corporate_name }}
                                </p>
                            </vs-td>
                        </vs-tr>
                    </tbody>
                </template>
            </vs-table>

            <vs-button
                color="primary"
                type="filled"
                class="align-right mr-5 mb-4"
                style="float: right;"
                @click.prevent="integrate()"
            >
                <span>Integrar</span>
            </vs-button>

            <div class="mt-3 mr-4">
                <vs-pagination
                :total="totalPages"
                v-model="currentPage"
            />
            </div>
        </vs-popup>
    </div>
</template>

<script>
    import ERP from '@/http/requests/syncCustomerErp';

    export default {
        name: 'ErpSyncModal',
        props: {
            isActive: {
                type: Boolean,
                required: true
            }
        },
        emits: [
            'isActiveFalse'
        ],
        data() {
            return {
                listERPs: [],
                totalPages: 0,
                currentPage: 1,
                maxPerPage: 4,
                previousNumberRegister: 0,
                nextNumberRegister: 0,
                selected: []
            }
        },
        methods: {
            async loadingData() {
                await ERP.fetch()
                .then((response) => {
                    const parsedData = response.data.data.getErp

                    this.registerLength = parsedData.length;   
                    this.totalPages = Math.ceil(this.registerLength/this.maxPerPage);
                    this.nextNumberRegister = this.maxPerPage;

                    return this.listERPs = parsedData;
                })
                .catch((error) => {
                    console.log(error)
                    return this.$vs.notify({
                        color: 'danger',
                        title: 'Erro',
                        text: 'Houve algum erro ao carregar os dados!'
                    });
                });
            },
            integrate() {
                if (this.selected.length === 0) {
                    return this.$vs.notify({
                        color: 'danger',
                        title: 'ERP não selecionada!',
                        text: 'Clique sobre a ERP que deseja integrar!'
                    });
                }
    
                this.$vs.loading({
                    type: 'radius'
                });

                ERP.SyncTrierCustomers(this.selected.id)
                .then(() => {
                    this.$emit('isActiveFalse');
                    this.$vs.loading.close();

                    return this.$vs.notify({
                        color: 'success',
                        title: 'A integração será feita:',
                        text: 'Os clientes serão integrados com a lista de contatos!'
                    });
                })
                .catch((exception) => {
                    console.log(exception);
                    this.$vs.loading.close();

                    return this.$vs.notify({
                        color: 'danger',
                        title: 'Houve algum erro ao integrar os clientes!'
                    });
                });
            }
        },
        async mounted() {
            await this.loadingData();
        },
        watch: {
            currentPage() {
                this.previousNumberRegister = (this.currentPage * this.maxPerPage) - this.maxPerPage;
                this.nextNumberRegister = this.currentPage * this.maxPerPage;
            },
            maxPerPage() {
                this.totalPages = Math.ceil(this.registerLength/this.maxPerPage);

                this.previousNumberRegister = (this.currentPage * this.maxPerPage) - this.maxPerPage;
                this.nextNumberRegister = this.currentPage * this.maxPerPage;

                if (this.currentPage > this.totalPages) {
                    this.currentPage = this.totalPages;
                }
            }
        },
    }
</script>

<style>
    #erprootmodal * {
        margin: 0;
    }
    #erprootmodal html {
        line-height: 1.5;
        letter-spacing: 0.02rem;
    }
    #erprootmodal table.vs-table.vs-table--tbody-table {
        border-collapse: separate;
        border-spacing: 0 1.3rem;
        padding: 0 1rem;
        background-color: white !important;
    }
    #erprootmodal .vs-con-tbody.vs-table--tbody {
        border: 0 !important;
    }
    #erprootmodal tbody > tr {
        height: 5em;
        box-shadow: 0 4px 20px 0 rgb(0 0 0 / 5%);
    }
    #erprootmodal thead > tr {
        background-color: transparent !important;
    }
    #erprootmodal .vs-table-text {
        text-transform: uppercase;
        font-size: 12px;
    }
    #erprootmodal input.input-search.vs-table--search-input {
        height: 45px;
    }
    /*#erprootmodal td.td.vs-table--td:first-of-type {
        border-radius: 5px;
    }
    #erprootmodal td.td.vs-table--td:last-of-type {
        border-radius: 5px;
    }*/
</style>